// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__9aM4x","amount":"Amount_amount__1gJj_","tip":"Amount_tip__3aRDw","tipHeader":"Amount_tipHeader__TqCH9","tipsWrap":"Amount_tipsWrap__jRRab"};